import InvoicePrivateApiModel from '../../abstracts/InvoicePrivateApiModel';

export default class ExportReadModel extends InvoicePrivateApiModel {
	static get path(): string {
		return '/exports/{?id}/read';
	}
}
